export default __webpack_public_path__ + "static/media/night.681cc17a.jpg";